import Vue from "vue";
import Vuex from "vuex";
import shoppingCart from "@/store/modules/shopping-cart";
import order from "@/store/modules/order";
import customer from "@/store/modules/customer";
import getters from "@/store/getters";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    shoppingCart,
    order,
    customer
  },
  getters
});
